
import React from "react";
import { CustomButton } from "../../../../components/Button/Button";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { RHFSwitch, RHFSelect, RFHTextField as RHFTextField } from "../../../../components/RFH";


export const UserFormFields = React.memo(({ teamsArray }) => {
    return (
      <>
        <RHFTextField name="first_name" label="First Name" className="mt-32" />
        <RHFTextField name="last_name" label="Last Name" className="mt-4" />
        <RHFTextField name="email" label="Email Address" className="mt-4" />
        <RHFSelect name="team" className="mt-4" label="Team">
          {teamsArray?.map((ele, idx) => (
            <CustomMenuItem key={`teamList-${idx}`} value={ele.team_id}>
              {ele.team}
            </CustomMenuItem>
          ))}
        </RHFSelect>
  
        <div className="d-flex justify-content-space-between mt-4">
          <p className="user_profile_head">Is Active</p>
          <RHFSwitch name={"isActive"} />
        </div>
  
        <div className="d-flex justify-content-space-between mt-4">
          <p className="user_profile_head">Worklogs Required</p>
          <RHFSwitch name={"worklogsRequired"} />
        </div>
  
        <div className="d-flex justify-content-space-between mt-4">
          <p className="user_profile_head">Is Super Admin</p>
          <RHFSwitch name={"isSuperAdmin"} />
        </div>
  
        <CustomButton
          type="submit"
          variant="contained"
          className="mt-25 user-profile-update-button"
          onClick={(e) => e.stopPropagation()}
        >
          Update
        </CustomButton>
      </>
    );
  });